// src/plugins/vuetify.js

import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';

// Add VSkeletonLoader to this main import list
import {
  VAlert, VApp, VAutocomplete, VBtn, VBtnToggle, VCard, VCardActions,
  VCardSubtitle, VCardText, VCardTitle, VChip, VChipGroup, VCol, VCombobox,
  VContainer, VDataTable, VDatePicker, VDialog, VDivider, VForm, VIcon,
  VImg, VList, VListItem, VListItemTitle, VMain, VMenu, VNavigationDrawer,
  VProgressCircular,
  VRow, VSelect,
  VSnackbar, VSpacer, VSwitch, VTab, VTabs, VTextField, VTextarea,
  VToolbar, VToolbarTitle, VTooltip, VWindow, VWindowItem, VSkeletonLoader
} from 'vuetify/components';

import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

export default createVuetify({
  components: {
    VAlert, VApp, VAutocomplete, VBtn, VBtnToggle, VCard, VCardActions,
    VCardSubtitle, VCardText, VCardTitle, VChip, VChipGroup, VCol, VCombobox,
    VContainer, VDataTable, VDatePicker, VDialog, VDivider, VForm, VIcon,
    VImg, VList, VListItem, VListItemTitle, VMain, VMenu, VNavigationDrawer,
    VProgressCircular,
    VRow, VSelect,
    VSnackbar, VSpacer, VSwitch, VTab, VTabs, VTextField, VTextarea,
    VToolbar, VToolbarTitle, VTooltip, VWindow, VWindowItem,
    VSkeletonLoader, // And ensure it's here
  },
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
});